<template>
  <div class="overflow-x-auto">
    <slot/>
  </div>
</template>

<script setup>
import { onMounted } from "vue"

const props = defineProps({
  tableId: { type: String, required: true },
  options: { type: Object },
})

onMounted(() => {
  $(`#${props.tableId}`).dataTable({
    paging: false,
    info: false,
    searching: true,
    dom: "t",
    columnDefs: [
      { targets: "data-table-no-sort", orderable: false },
      { targets: "data-table-number", type: "title-numeric" },
    ],
    ...props.options,
  })
})
</script>
